interface Props {
    title: string;
    value: string;
    icon: React.ReactElement;
}

const TaskItem: React.FC<Props> = ({ title, value, icon }) => {
    return (
        <div className='flex items-center p-4'>
            <div className='flex flex-1 items-center gap-2 text-sm text-gray-600'>
                {icon}
                <span>{title}</span>
            </div>
            <span className='text-sm font-semibold text-gray-900'>{value}</span>
        </div>
    );
};

export default TaskItem;

